import { Permissions } from "generated";
import { debounce, throttle } from "../lib/utils.js";

export class PermissionsManager {
    constructor() {
        this.hasPermissions = true;
        this.global = Permissions.globalPermissions || {};
        this.elementsPermissions = Permissions.elementsPermissions || {};
        this.elementsControlRightNames = Permissions.elementsControlRightNames || {};
        this.objectsPermissions = Permissions.objectsPermissions || {};
        this.windowsPermissions = Permissions.windowsPermissions || {};
        this.operatorsRoles = Permissions.operatorsRoles || {};
        this.operatorsMnemos = Permissions.operatorsMnemos || {};
        this.logActionTry = Permissions.logActionTry || {};
        this.emptyPermConst = "0000";
        this.allRoleConst = "_All";
        this.permissionTypes = {
            Action: "Действие",
            Control: "Управление",
            OpenWindow: "Открытие окна",
            ChangeUsers: "Смена пользователя",
            ChangeSelfPassword: "Изменение пароля",
            JournalAck: "Квитирование сообщения",
            JournalGroupAck: "Групповое квитирование сообщений",
            JournalUseFilters: "Использование фильтров в журнале",
            JournalPrint: "Печать сообщений",
            JournalSave: "Экспорт сообщений",
            TrendAddPens: "Изменение состава перьев",
            TrendChangePens: "Изменение настройки перьев, изменение шкалы",
            TrendSave: "Экспорт графика",
            TrendPrint: "Печать графика",
            DataTableEdit: "Редактирование ячеек таблицы",
            DataTableFilter: "Использование фильтров в таблице",
        };

        this.rtObjectRights = {};
        this.rtWindowsRights = {};
        this.rtElementsRights = {};

        this.addUserActivitiesData();
    }

    openUserWindow(customWin) {
        if (this.hasPermissions) {
            const permit = this.checkOpenWindowRights(customWin);
            //                                                /\
            //стартовые окна не могут быть экземплярами, поэтому контекст не обязателен
            if (!permit) {
                const item = {
                    type: "error",
                    time: new Date().toLocaleString(),
                    title: i18next.t("title_not_rights_to_window"),
                    text: i18next.t("not_rights_to_open"),
                };
                $ns.add(item);
                return false;
            }
        }
        const frame = document.getElementById($WinDefs.constructor.mainFrame[window.activeMonitorTemplateId]);
        if (frame) frame.openWindow($WinDefs.winDef[customWin]);
        return true;
    }

    checkCurrentWindow() {
        const firstWin = document.getElementById(
            $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId]
        ).firstChild;
        if (firstWin) {
            const curWin = firstWin.id;
            return this.checkOpenWindowRights(curWin, firstWin);
        }
    }

    getStartWindow() {
        if (Object.keys(this.operatorsMnemos).length > 0) {
            let intersec = this.getUsersIntersec(this.operatorsMnemos);
            if (intersec && intersec.length === 1)
                return this.operatorsMnemos[intersec[0]];
            if (intersec && intersec.length > 1) {
                //если пользователь состоит в нескольких группах
                //и для этих групп заданы стартовые окна
                //вернем первое разрешенное окно из списка групп
                for (let i = 0; i < intersec.length; i++) {
                    const startMnemo = this.operatorsMnemos[intersec[i]];
                    if (this.checkOpenWindowRights(startMnemo)) {
                        return startMnemo;
                    }
                }
            }
        }
    }

    //for silent mode, where we dont have confirmation and action based opening
    checkOpenWindowRights(winId, context) {
        const entry = this.getEntryFromWindowType(winId, "OpenWindow", context);
        return this.checkAllow(entry);
    }

    setOperatorRoles(operator, roles) {
        this.currentOp = operator;
        if (typeof roles !== "undefined" && roles.length > 0) {
            if (typeof roles[0] === "string") {
                this.operatorsRoles[operator] = roles;
            } else if (roles[0] !== null && typeof roles[0] === "object") {
                this.operatorsRoles[operator] = roles.map(x => x.name);
            }
        }
        this.changeUsersList(operator);
        //this.saveRtRights()
    }

    setRtRights(data) {
        if (typeof data.rights === "object") {
            this.resetRtRights();
            this.addToRTStore(
                data.rights,
                (objId, rights) => (this.rtObjectRights[objId] = rights)
            );
        }
    }

    saveRtRights() {
        this.saveRight("rtElementsRights", this.rtElementsRights);
        this.saveRight("rtWindowsRights", this.rtWindowsRights);
        this.saveRight("rtObjectRights", this.rtObjectRights);
    }

    saveRight(key, rightObj) {
        if (typeof rightObj === "object") {
            $ss.saveToStorage(key, rightObj);
        }
    }

    restoreRights() {
        this.rtObjectRights = $ss.getFromStorage("rtObjectRights") || {};
        this.rtWindowsRights = $ss.getFromStorage("rtWindowsRights") || {};
        this.rtElementsRights = $ss.getFromStorage("rtElementsRights") || {};
    }

    resetRtRights() {
        this.rtObjectRights = {};
        this.rtWindowsRights = {};
        this.rtElementsRights = {};
        this.saveRtRights();
    }

    addToRTStore(object, addFunc, stopSignal = false, ...args) {
        let keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const objectEntry = object[key];

            let rights = stopSignal ? objectEntry : objectEntry.rights;
            if (typeof rights === "object" && Object.keys(rights).length > 0) {
                addFunc(key, rights, ...args);
            }
            if (stopSignal) continue;
            //права окон
            if (
                typeof objectEntry.windows === "object" &&
                Object.keys(objectEntry.windows).length > 0
            ) {
                this.addToRTStore(
                    objectEntry.windows,
                    (winName, rights, objId) =>
                        this.addWindowRtRights(winName, rights, objId),
                    false,
                    key
                );
            }
            //права контролов
            else {
                let copyObjEntry = { ...objectEntry };
                delete copyObjEntry.rights;
                if (Object.keys(copyObjEntry).length > 0) {
                    this.addToRTStore(
                        copyObjEntry,
                        (controlName, rights, winName, objId) =>
                            this.addControlRtRights(
                                controlName,
                                rights,
                                winName,
                                objId
                            ),
                        true,
                        key,
                        ...args
                    );
                }
            }
        }
    }

    addWindowRtRights(winName, rights, objId) {
        const winId = $pr.getWindowIdByName(winName, objId);
        if (winId != null) {
            this.rtWindowsRights[winId] = rights;
        }
    }

    addControlRtRights(elementName, rights, winName, objId) {
        const winId = $pr.getWindowIdByName(winName, objId);
        if (winId != null) {
            if (typeof this.rtElementsRights[winId] !== "undefined") {
                let temp = this.rtElementsRights[winId];
                this.rtElementsRights[winId] = {
                    ...temp,
                    [elementName]: rights,
                };
            } else {
                this.rtElementsRights[winId] = { [elementName]: rights };
            }
        }
    }

    getStoredPermission(element, winTypeId, usersList, permType) {
        const rtRights = this.rtElementsRights[winTypeId];
        if (typeof rtRights !== "undefined") {
            return false;
        }
        return element.getPermission(usersList, permType);
    }

    getElementPermission(element, winId) {
        const rtRights = this.rtElementsRights[winId];
        if (typeof rtRights !== "undefined") {
            let elementName = element.elname;
            let elementRights = rtRights[elementName];
            if (typeof elementRights !== "undefined") {
                return elementRights;
            }
        }
        const permContainer = this.elementsPermissions[winId];
        if (typeof permContainer !== "undefined") {
            let elementId = element.id;
            let elementRights = permContainer[elementId];
            if (typeof elementRights !== "undefined") {
                return elementRights;
            }
        }
    }

    getElementRightName(element) {
        const controlRightName = this.elementsControlRightNames[element.id];
        if (typeof controlRightName !== "undefined") {
            return controlRightName;
        }
    }

    getWindowPermission(typeId) {
        let rtRights = this.rtWindowsRights[typeId];
        let dtRights = this.windowsPermissions[typeId];
        return typeof rtRights !== "undefined" ? rtRights : dtRights;
    }

    getObjectPermission(objectId) {
        let rtRights = this.rtObjectRights[objectId];
        let dtRights = this.objectsPermissions[objectId];
        return typeof rtRights !== "undefined" ? rtRights : dtRights;
    }

    changeUsersList(operator) {
        if (!operator) {
            operator = this.currentOp;
        }
        let roles =
            this.operatorsRoles && new Set(this.operatorsRoles[operator]);
        if (typeof roles !== "undefined" && roles.size > 0) {
            roles.add(operator);
            roles.add(this.allRoleConst);
            this.usersList = Array.from(roles);
        } else {
            this.usersList = [operator, this.allRoleConst];
        }
    }

    getParentWindow(element) {
        let temp = element;
        while (temp && temp.nodeName !== "MS-WINDOW") {
            temp = temp.parentNode;
        }
        return temp;
    }

    getObjectId(typeId, context) {
        let objId = Number(
            $WinDefs.winDef[typeId] && $WinDefs.winDef[typeId].objectid
        );
        if (!objId && context) {
            objId = $sw.ItemSubscription._getParentParam(context, "objectid");
        }
        return objId;
    }

    controlEnable(childs) {
        if (childs?.length > 0 && (_globalParams.BlockDisabledControls || _globalParams.DisabledControlsTooltip)) {
            Array.from(childs)
                // Редактор, в процессе генерации HTML, между web-компонентами может добавлять пробелы или табуляцию,
                // их нужно исключить также как и web-компоненты, находящиеся в состоянии "disconnected"
                .filter(ch => ch.nodeType === 1 && customElements.get(ch.localName) && !ch.isdisconnected)
                .forEach(ch => {
                    //dont disable containers,
                    //it possibly contains special allow
                    if (ch.childNodes.length > 0) {
                        this.controlEnable(ch.childNodes);
                    } else {
                        let entry = this.getEntryFromElement(ch, "Control");
                        let disable = !this.checkAllow(entry);
                        if (_globalParams.BlockDisabledControls)
                            ch.setControlDisable(disable);
                        else if (_globalParams.DisabledControlsTooltip) {
                            let tooltip = ch.tooltip;
                            if (tooltip)
                                ch.dataset.tooltip = disable
                                    ? _globalParams.DisabledControlsTooltip
                                    : tooltip;
                        }
                    }
                });
        }
    }

    isPermDisabled(control, permType) {
        const isPermAllowed = this.hasPermissions ? this.checkAllow(this.getEntryFromElement(control, permType)) : true;
        return _globalParams.BlockDisabledControls && !isPermAllowed;
    }

    checkEnable(element) {
        return this.hasPermissions ? this.checkAllow(this.getEntryFromElement(element, "Control")) : true;
    }

    getEntryFromElement(element, permType) {
        const parentWin = this.getParentWindow(element);
        const windowTypeId = parentWin && parentWin.typeid;
        let result = this.getStoredPermission(
            element,
            windowTypeId,
            this.usersList,
            permType
        );
        if (result) {
            return {
                result,
                permType
            };
        }

        const windowId = parentWin && parentWin.id;
        let node = element;
        let rightsMask = 0;
        let reducedUsers = {};

        if (permType === "Control") {
            const elRightName = this.getElementRightName(node);
            if (typeof elRightName !== "undefined") {
                node = node.parentNode;
                permType = elRightName;
            }
        }
        do {
            const elPerm = this.getElementPermission(node, windowId);
            if (typeof elPerm !== "undefined")
                rightsMask = this.getCombinedRights(
                    rightsMask,
                    reducedUsers,
                    elPerm[permType],
                    this.usersList
                );
            else if (node == element && parentWin == element) {
                const parentWinReal = this.getParentWindow(element.parentNode);
                if (parentWinReal) {
                    const elWinPerm = this.getElementPermission(
                        node,
                        parentWinReal.id
                    );
                    if (typeof elWinPerm !== "undefined")
                        rightsMask = this.getCombinedRights(
                            rightsMask,
                            reducedUsers,
                            elWinPerm[permType],
                            this.usersList
                        );
                }
            }

            if (windowTypeId) {
                const elTypePerm = this.getElementPermission(
                    node,
                    windowTypeId
                );
                if (typeof elTypePerm !== "undefined")
                    rightsMask = this.getCombinedRights(
                        rightsMask,
                        reducedUsers,
                        elTypePerm[permType],
                        this.usersList
                    );
            }

            if (node.id == windowId) break;
            node = node.parentNode;
        } while (node && node.id != windowId);

        const winPerms = this.getWindowPermission(windowId);
        if (typeof winPerms !== "undefined")
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                winPerms[permType],
                this.usersList
            );

        const winTypePerms = this.getWindowPermission(windowTypeId);
        if (typeof winTypePerms !== "undefined")
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                winTypePerms[permType],
                this.usersList
            );

        const objectId = this.getObjectId(windowTypeId, element);
        if (typeof objectId !== "undefined")
            rightsMask = this.getCombinedObjectRights(
                rightsMask,
                reducedUsers,
                objectId,
                permType
            );

        const globalPerm = this.global[permType];
        if (typeof globalPerm !== "undefined")
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                globalPerm.rights,
                this.usersList
            );

        result = this.reduceEntries(rightsMask);
        element.setPermission(this.usersList, permType, result);
        return {
            result,
            permType: typeof globalPerm !== "undefined" ? globalPerm.displayName : permType,
            requirePassword: typeof globalPerm !== "undefined" ? globalPerm.requirePassword : false,
        };
    }

    getEntryFromWindowType(typeId, permType, context, objectId) {
        let rightsMask = 0;
        let reducedUsers = {};
        const winTypePerms = this.getWindowPermission(typeId);
        if (typeof winTypePerms !== "undefined")
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                winTypePerms[permType],
                this.usersList
            );

        if (typeof objectId !== "undefined")
            rightsMask = this.getCombinedObjectRights(
                rightsMask,
                reducedUsers,
                objectId,
                permType
            );

        const globalPerm = this.global[permType];
        if (typeof globalPerm !== "undefined")
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                globalPerm.rights,
                this.usersList
            );

        return {
            result: this.reduceEntries(rightsMask),
            permType: typeof globalPerm !== "undefined" ? globalPerm.displayName : permType
        }
    }

    getCombinedObjectRights(rightsMask, reducedUsers, objectId, permType) {
        const objPerm = this.getObjectPermission(objectId);
        if (typeof objPerm !== "undefined") {
            rightsMask = this.getCombinedRights(
                rightsMask,
                reducedUsers,
                objPerm[permType],
                this.usersList
            );

            const objParent = objPerm.parentId;
            if (typeof objParent !== "undefined")
                rightsMask = this.getCombinedObjectRights(
                    rightsMask,
                    reducedUsers,
                    objParent,
                    permType
                );
        }
        return rightsMask;
    }

    /*from perms list exract users intersected with current users list */
    getUsersIntersec(perms) {
        return (
            typeof perms !== "undefined" &&
            Object.keys(perms).filter(x => this.usersList.includes(x))
        );
    }

    getCombinedRights(rightsMask, reducedUsers, rights, users) {
        if (typeof rights === "undefined") return rightsMask;
        return users.reduce((acc, cur) => {
            if (
                !reducedUsers.hasOwnProperty(cur) &&
                rights.hasOwnProperty(cur)
            ) {
                reducedUsers[cur] = true;
                return acc | rights[cur];
            } else return acc;
        }, rightsMask);
    }

    reduceEntries(...entries) {
        let reducedEntry = entries
            .reduce((acc, cur) => acc | cur, 0)
            .toString(2);
        /*adding leading zeros for normalize length*/
        return "0000".substr(reducedEntry.length) + reducedEntry;
    }

    resolveOpenWindow(context, windId, objectId, callback) {
        const optype = "OpenWindow";
        const entryForWindow = this.getEntryFromWindowType(
            windId,
            optype,
            context,
            objectId
        );
        //const entryForContext = this.getEntryFromElement(context, optype);
        //const result = this.reduceEntries(parseInt(entryForContext, 2), parseInt(entryForWindow, 2));
        const win = $WinDefs.winDef[windId];
        const text =
            typeof win !== "undefined"
                ? `${this.getPermissionText(optype)}: ${win.elname}`
                : this.getPermissionText(optype);
        this.resolveAction(context, entryForWindow, optype, callback, {
            customText: text,
            customDialogText: text,
        });
    }

    resolveControl(context, optypeDesc, callback, options) {
        const optype = optypeDesc === "Action" ? "Control" : optypeDesc;
        const entry = this.getEntryFromElement(context, optype);
        return this.resolveAction(context, entry, entry.permType, callback, options);
    }

    resolveAction(context, entry, optype, callback, options) {
        return this.checkAllow(entry)
            ? this.allowOperation(context, entry, optype, callback, options)
            : this.forbidOperation(context, optype, options?.customText, options);
    }

    showErrorIfDisabled(context, optypeDesc, options) {
        if (!this.hasPermissions)
            return;
        const optype = optypeDesc === "Action" ? "Control" : optypeDesc;
        const entry = this.getEntryFromElement(context, optype);
        if (!this.checkAllow(entry))
            this.forbidOperation(context, optype, options?.customText, options);
    }

    allowOperation(context, entry, optype, callback, options) {
        const {
            customText,
            customDialogText,
            uid = 0,
            cancel,
            forced = false,
            callbackData
        } = options || {};
        const { beforeCallbackFn, afterCallbackFn, event } =
            callbackData || {};
        if (this.Confirmation(entry) && !forced) {
            if (this.getLogActionTryFlag() && this.WriteLog(entry)) {
                this.reportAction(context, optype, customText, true, false, event);
            }
            return $confirm(
                this.executeOperation.bind(
                    this,
                    context,
                    entry,
                    optype,
                    callback,
                    customText,
                    event
                ),
                customDialogText || this.composeActionText(context, optype, customText),
                uid,
                cancel,
                callbackData,
                entry.requirePassword,
            );
        } else {
            beforeCallbackFn && beforeCallbackFn();
            let res = this.executeOperation(
                context,
                entry,
                optype,
                callback,
                customText,
                event
            );
            afterCallbackFn && afterCallbackFn();
            return res;
        }
    }

    forbidOperation(context, optype, customText, options) {
        if (this.getLogActionTryFlag()) {
            this.reportAction(context, optype, customText, false, true, options?.callbackData?.event);
        }

        if (!window._globalParams.EnableNoPermissionInformationWindow) {
            // Запрещаем отображение модального окна об отсутствии прав на выполнение действия
            return;
        }

        window._allert("Недостаточно прав для выполнения действия: " + this.composeActionText(context, optype, customText));
    }

    executeOperation(context, entry, optype, callback, customText, event) {
        if (this.WriteLog(entry)) {
            this.reportAction(context, optype, customText, false, false, event);
        }
        return callback && callback();
    }

    getLogActionTryFlag() {
        let intersec = this.getUsersIntersec(this.logActionTry);
        if (intersec.length === 1) return this.logActionTry[intersec[0]];
        else {
            //если пользователь состоит в нескольких группах
            //и флаг логировать попытки действий true хотя бы в одной, то логируем
            return intersec.reduce(
                (acc, cur) => this.logActionTry[cur] || acc,
                false
            );
        }
    }

    composeActionText(context, optype, customText) {
        if (typeof customText !== "undefined") {
            return customText;
        }

        const tmp = Object.keys(context.actions)[0]
            ? context.actions[Object.keys(context.actions)[0]]
            : null;

        const message =
            tmp && tmp.event_parameters ? tmp.event_parameters.message : null;
        if (message) {
            return message;
        }

        const permname = this.getPermissionText(optype);
        return _globalParams.DisplayItemNamesInMessages
            ? `${permname}: ${context.elname}`
            : permname;
    }

    reportAction(
        context,
        optype,
        customText,
        logActionTry,
        logDisabledActionTry,
        event
    ) {
        if (event) {
            if (this.lastEvent === event)
                return;
            this.lastEvent = event;
        }

        const wind = this.getParentWindow(context);
        const windId = wind && wind.typeid;
        const objId = this.getObjectId(windId, context);

        let text = this.composeActionText(context, optype, customText);
        if (logDisabledActionTry)
            text = "Недостаточно прав для выполнения действия: " + text;
        else if (logActionTry) text = "Попытка действия: " + text;
        $sw.ReportAction(context.id, objId, text, context.elname);
    }

    getPermissionText(optype) {
        const result = this.permissionTypes[optype];
        if (typeof result === "undefined") return optype;
        return result;
    }

    checkAllow(entry) {
        return this.Enable(entry) && !this.Disable(entry);
    }

    Enable({ result }) {
        return !!(result && result[3] === "1");
    }

    Disable({ result }) {
        return !!(result && result[2] === "1");
    }

    Confirmation({ result }) {
        return !!(result && result[1] === "1");
    }

    WriteLog({ result }) {
        return !!(result && result[0] === "1");
    }

    addUserActivitiesData() {
        this.userActivitiesData = {
            wheel: [() => throttle(this.resetTimer, 1000)],
            scroll: [() => throttle(this.resetTimer, 1000), true],
            mousemove: [() => throttle(this.resetTimer, 1000)],
            mousedown: [() => debounce(this.resetTimer, 1000)],
            touchstart: [() => debounce(this.resetTimer, 1000)],
            click: [() => debounce(this.resetTimer, 1000)],
            keydown: [() => debounce(this.resetTimer, 1000)],
        };
        this.userActivitiesEvents = Object.keys(this.userActivitiesData);
    }

    /**
     * Наблюдаем за активностью пользователя и
     * вызываем переданный callback по истечению таймера простоя inactivityTimer
     *
     * @param {number} inactivityTimer таймер, после которого будет вызван callback
     * @param {function} callback коллбек
     */
    startWatchUserActivity(inactivityTimer, callback) {
        this.inactivityTimer = inactivityTimer;
        if (this.resetTimer) {
            // очищаем слушатели событий, которые могли быть добавлены для предыдущего пользователя
            this.stopWatchUserActivity();
        }

        this.resetTimer = () => {
            clearTimeout(this.userActivityTimer);

            if (!this.resetTimer) {
                return;
            }

            this.userActivityTimer = setTimeout(() => {
                this.removeUserActivityListeners();
                callback();
            }, this.inactivityTimer);
        };

        if (!this.userActivitiesCallbacks) {
            this.userActivitiesCallbacks = this.userActivitiesEvents.map(x => {
                const [fn, useCapture] = this.userActivitiesData[x];
                return [fn(), useCapture];
            });
        }

        this.userActivitiesEvents.forEach((x, i) =>
            window.addEventListener(x, ...this.userActivitiesCallbacks[i])
        );

        this.resetTimer(); // На случай, если юзер после того, как залогинился не будет производить никаких действий
    }

    stopWatchUserActivity() {
        if (!this.userActivitiesCallbacks) {
            return;
        }
        clearTimeout(this.userActivityTimer);
        this.removeUserActivityListeners();
        this.resetTimer = null;
    }

    removeUserActivityListeners() {
        Object.keys(this.userActivitiesData).forEach((x, i) =>
            window.removeEventListener(x, ...this.userActivitiesCallbacks[i])
        );
    }
}